module.exports = __webpack_public_path__ + "img/single-img-18-p-800.45d97d85.jpg";